module.exports = __webpack_public_path__ + "fonts-3ec3e0c9f095e33ff20b243d9b4e5529-GT-Eesti-Pro-Display-Regular-subset.woff2";